import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { mapState } from 'vuex';
import { insuranceResource } from '@/views/insurance/insuranceManage/request';
import { customerResource } from '@/views/system/customerManage/request';
import { insuranceInfoMark, classificationCustomerList, customerClassification } from '@/views/insurance/releaseManage/request';
import { applicationResource2 } from './../../../customer/applicationManage/request';
import { paymentMethodEcho, paymentMethodEcho2 } from '@/views/payment/merchantManage/request';
import { TripartiteCOLUMN, EproCOLUMN } from '@/views/insurance/releaseManage/utils';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { editCustomerInsurance, customerInsuranceDetail } from './../request.js';
export default {
  components: {
    topTitle
  },
  props: {
    customerInsuranceId: {
      type: Number,
      default: -1,
      required: true
    },
    mark: {
      type: String,
      default: ''
    }
  },
  data() {
    // const validatePaymentMethods= (rule, value, callback) => {
    //   if (!this.dataForm.paymentMethods.payWay) {
    //     callback(new Error('请输入支付方式'));
    //   } else {
    //     callback();
    //   }
    // };
    // const validatePaymentMethods2= (rule, value, callback) => {
    //   if (this.dataForm.paymentMethods.payWay == 2 || this.dataForm.paymentMethods.payWay == 5) {
    //     if (this.payObj.payList.length == 0) {
    //       callback(new Error('请配置账户信息'));
    //     } else {
    //       callback();
    //     }
    //   } else {
    //     callback();
    //   }
    // };
    return {
      mainList: [],
      customerList: [],
      applicationList: [],
      classificationList: [],
      labelList: [],
      labelIds: [],
      payObj: {
        payList: []
      },
      form: {
        name: {
          isEdit: false
        }
      },
      dataForm: {
        mark: undefined,
        customerId: undefined,
        applicationId: undefined,
        isRetraceable: undefined,
        isInvoice: 0,
        //0不开发票 1开发票
        invoiceSendMethod: 'EXTERNAL',
        isInvoiceOffset: 0,
        //0否 1是
        classificationId: undefined,
        labelIds: '',
        paymentMethods: {
          payWay: undefined
        }
      },
      intermediariesShow: false,
      TripartiteCOLUMN,
      EproCOLUMN,
      eproShow: false,
      EproPayCOLUMN: []
    };
  },
  created() {
    insuranceResource({}).then(res => {
      this.mainList = res;
    });
    customerResource().then(res => {
      this.customerList = res;
    });
  },
  mounted() {
    if (this.customerInsuranceId != -1) {
      console.log(this.mark, 333);
      this.getInfo();
    }
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          min: 5,
          message: this.$t('至少输入5个字符'),
          trigger: 'blur'
        }, {
          max: 50,
          message: this.$t('最多输入50字符'),
          trigger: 'blur'
        }]
      };
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  methods: {
    async getInfo() {
      const res = await customerInsuranceDetail({
        customerInsuranceId: this.customerInsuranceId,
        mark: this.mark
      });
      const {
        items
      } = await classificationCustomerList({
        customerId: res.customerId
      });
      this.applicationList = await applicationResource2({
        customerId: res.customerId
      });
      this.classificationList = items;
      this.dataForm = {
        customerInsuranceId: this.customerInsuranceId,
        mark: res.insuranceMark,
        name: res.name.name,
        customerId: res.customerId,
        applicationId: res.applicationId,
        isRetraceable: res.isRetraceable,
        isGenerateQr: res.isGenerateQr,
        isInvoice: res.isInvoice,
        invoiceSendMethod: res.invoiceSendMethod || 'EXTERNAL',
        isInvoiceOffset: res.isInvoiceOffset || 0,
        classificationId: res.classificationId ? res.classificationId : undefined,
        declarationMethod: res.declarationMethod ? res.declarationMethod : undefined,
        labelIds: '',
        paymentMethods: res.paymentMethods
      };
      if (res.paymentMethods.payList.length != 0) {
        this.getAccount(res.paymentMethods);
      }
      this.form = res.insuranceInfo;
      const classificationObj = this.classificationList.find(item => item.id == this.dataForm.classificationId);
      if (this.dataForm.classificationId && classificationObj) {
        this.labelList = await customerClassification({
          classificationId: this.dataForm.classificationId
        });
        const labelIdsArr = res.labelIds.split(',');
        this.labelIds = [];
        labelIdsArr.map(item => {
          const obj = this.labelList.find(item2 => item2.id == item);
          if (obj) {
            this.labelIds.push(String(obj.labelId));
          }
        });
      } else {
        this.dataForm.classificationId = undefined;
        this.labelIds = [];
      }
    },
    async markChange(val) {
      this.form = await insuranceInfoMark({
        mark: this.dataForm.mark
      });
      this.dataForm.name = this.form.name.name;
      this.dataForm.insuranceId = this.form.insuranceId;
      console.log(this.form);
    },
    async customerChange() {
      this.applicationList = await applicationResource2({
        customerId: this.dataForm.customerId
      });
      const {
        items
      } = await classificationCustomerList({
        customerId: this.dataForm.customerId
      });
      this.classificationList = items;
      this.dataForm.applicationId = undefined;
      this.dataForm.classificationId = undefined;
      this.labelIds = [];
    },
    async classificationChange() {
      this.labelIds = [];
      this.labelList = [];
      if (this.dataForm.classificationId) {
        this.labelList = await customerClassification({
          classificationId: this.dataForm.classificationId
        });
      }
    },
    payWayChange() {
      this.payObj.payList = [];
    },
    async configureAccountFun() {
      if (this.dataForm.paymentMethods.payWay == 2) {
        this.intermediariesShow = true;
        this.$nextTick(() => {
          this.$refs.intermediariesRef.init(this.form, this.dataForm, this.payObj);
        });
      } else {
        let obj = {
          payList: []
        };
        if (this.payObj.payList != 0) {
          obj = await paymentMethodEcho2({
            paymentMethods: JSON.stringify(this.dataForm.paymentMethods),
            type: 4
          });
        }
        this.eproShow = true;
        this.$nextTick(() => {
          this.$refs.eproRef.init(this.form, this.dataForm, obj);
        });
      }
    },
    async getAccount(val) {
      var _this$$refs$paymentMe;
      this.dataForm.paymentMethods = val;
      if (val.payWay == 5) {
        this.EproPayCOLUMN = recursionCopy(this.EproCOLUMN);
        if (val.amountSplitting != 3) {
          if (val.splitSetup == 1) {
            this.EproPayCOLUMN.push({
              slots: {
                title: '收款比例'
              },
              dataIndex: 'shareRatio',
              key: '3',
              align: 'center',
              scopedSlots: {
                customRender: 'shareRatio'
              }
            });
          } else {
            this.EproPayCOLUMN.push({
              slots: {
                title: '分账金额'
              },
              dataIndex: 'share',
              key: '3',
              align: 'center'
            });
          }
        }
      }
      this.payObj = await paymentMethodEcho({
        paymentMethods: JSON.stringify(val)
      });
      (_this$$refs$paymentMe = this.$refs.paymentMethods2) === null || _this$$refs$paymentMe === void 0 || _this$$refs$paymentMe.onFieldChange();
    },
    addKeyWordHighline(oText, keyWords) {
      if (!oText || !keyWords) {
        return '';
      }
      let returnVal = oText;
      let i = 0;
      let wordReg;
      for (i = 0; i < keyWords.length; i++) {
        if (keyWords[i] !== '') {
          wordReg = new RegExp(`(?!<font+>.[^<]*)${keyWords[i]}(?!.[^<]*<\\/font>)`, 'g');
          returnVal = returnVal.replace(wordReg, `<font color='#1890ff'>${keyWords[i]}</font>`);
        }
      }
      return returnVal;
    },
    nextFun() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          if (this.$route.params.type == 1) {
            let parameters = recursionCopy(this.dataForm);
            if (parameters.paymentMethods.payWay != 2 && parameters.paymentMethods.payWay != 5) {
              parameters.paymentMethods.payList = [];
            }
            if (this.labelIds.length != 0) {
              parameters.labelIds = this.labelIds.join(',');
            }
            parameters.name = JSON.stringify({
              name: this.dataForm.name,
              isEdit: this.form.name.isEdit
            });
            parameters.paymentMethods = JSON.stringify(parameters.paymentMethods);
            const res = await editCustomerInsurance(parameters);
            console.log(parameters, res);
            this.$message.success(this.$t('操作成功'));
            this.$emit(this.$t('next'), res);
          } else {
            this.$emit(this.$t('next'), {});
          }
        }
      });
    }
  }
};